import React, { useEffect, useRef, useState } from 'react'
import Lottie from 'react-lottie'
import { Box, makeStyles } from '@material-ui/core'
import { useOnScreen } from '../utils/dom'
import Image from './Image'

const AnimatedPhoneSet = ({
  style,
  animationPath,
  animationDelay,
  placeholderPath,
}) => {
  const lottieBoxRef = useRef()
  const isVisible = useOnScreen(lottieBoxRef) // false
  const [isPaused, setIsPaused] = useState(!!animationDelay) // false
  const [resetTimeout, setResetTimeout] = useState()
  const [isStopped, setIsStopped] = useState(false)
  const styles = useStyles()

  useEffect(() => {
    if (isVisible) {
      if (isPaused) {
        const timeout = setTimeout(() => {
          setIsPaused(false)
          setIsStopped(false)
        }, animationDelay)
        setResetTimeout(timeout)
      }
    } else {
      setIsPaused(true)
      if (resetTimeout) {
        clearTimeout(resetTimeout)
        if (animationDelay) {
          setIsStopped(true)
        }
      }
    }
  }, [isVisible])

  return (
    <Box ref={lottieBoxRef} className={style}>
      {placeholderPath && (
        <Image file={{ url: placeholderPath }} className={styles.placeHolder} />
      )}
      {animationPath && (
        <Lottie
          options={{
            autoplay: !animationDelay,
            loop: !animationDelay,
            path: animationPath,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          width="100%"
          isPaused={isPaused}
          isStopped={isStopped}
        />
      )}
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  placeHolder: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
}))

export default AnimatedPhoneSet
